import PropTypes from 'prop-types';
import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { isAntivirusFileScanEnabled } from '../../../../../../../../core/constants/launchDarklyFeatureFlags';

import AulaEditorWithAnalyticsWithoutPlugins from '../../../../../common/AulaEditor/AulaEditorWithAnalyticsWithoutPlugins';

const AulaEditor = ({
  config,
  editorState,
  onChange,
  spaceId,
  fileScanStatus,
  onFilesStatusChange,
}) => {
  const flags = useFlags();
  const enableFileScanStatus = isAntivirusFileScanEnabled(flags);

  const fullConfig = React.useMemo(
    () => ({
      ...config,
      spaceId,
      ...(enableFileScanStatus && {
        fileScanStatus,
        enableFileScanStatus: true,
      }),
    }),
    [config, spaceId, enableFileScanStatus, fileScanStatus]
  );

  const handleEditorChange = React.useCallback(
    (state) => {
      onChange(state, fullConfig);
    },
    [onChange, fullConfig]
  );

  return (
    <AulaEditorWithAnalyticsWithoutPlugins
      config={fullConfig}
      editorState={editorState}
      onChange={handleEditorChange}
      type="assignmentExtensions"
      onFilesStatusChange={onFilesStatusChange}
    />
  );
};

AulaEditor.propTypes = {
  config: PropTypes.shape({
    filesUrl: PropTypes.string.isRequired,
    apiUrl: PropTypes.string.isRequired,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  editorState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  spaceId: PropTypes.string.isRequired,
  fileScanStatus: PropTypes.objectOf(PropTypes.string),
};

export default AulaEditor;
